import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAppData } from '../store';
import { PROJECT_STATUS_LABELS, PROJECT_STATUS_ORDER, type ProjectStatus } from '../types';
import ProjectCard from './ProjectCard';

const ACTIVE_STATUSES: ProjectStatus[] = ['idea', 'planned', 'in_progress'];

export default function ProjectList() {
  const { projects, loading } = useAppData();
  const [showDone, setShowDone] = useState(false);

  if (loading) return <div className="loading-screen">Loading…</div>;

  const statuses = showDone ? PROJECT_STATUS_ORDER : ACTIVE_STATUSES;
  const byStatus = statuses
    .map((status) => ({
      status,
      projects: projects.filter((p) => p.status === status),
    }))
    .filter((g) => g.projects.length > 0);

  const doneCount = projects.filter((p) => p.status === 'done').length;

  return (
    <div className="project-list">
      <div className="page-header">
        <h1>Projects</h1>
        <Link to="/projects/new" className="btn-primary">
          + Add project
        </Link>
      </div>

      {projects.length === 0 && (
        <p className="muted empty">
          No projects yet. Track the bigger, open-ended things — renovations, builds, anything
          without a fixed due date.
        </p>
      )}

      {byStatus.map(({ status, projects: group }) => (
        <section key={status} className="dashboard-section">
          <h2>{PROJECT_STATUS_LABELS[status]}</h2>
          <div className="card-list">
            {group.map((project) => (
              <ProjectCard key={project.id} project={project} />
            ))}
          </div>
        </section>
      ))}

      {doneCount > 0 && (
        <button type="button" className="btn-secondary small" onClick={() => setShowDone((s) => !s)}>
          {showDone ? 'Hide' : 'Show'} {doneCount} done project{doneCount === 1 ? '' : 's'}
        </button>
      )}
    </div>
  );
}
